/** Quita etiquetas HTML y deja solo el texto visible (p. ej. títulos de curso). */
export const stripHtml = (html) => {
  if (html == null || html === '') return '';
  const raw = String(html);
  if (typeof window !== 'undefined' && typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(raw, 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  }
  return raw.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
};

const stringUtils = {
    stripHtml,

    // Convierte la primera letra de una palabra o frase en mayúscula
    capitalize: (str) => {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  
    // Convierte todas las palabras de una frase a capitalized (cada palabra con mayúscula inicial)
    capitalizeWords: (str) => {
      if (!str) return '';
      return str
        .split(' ')
        .map(word => stringUtils.capitalize(word))
        .join(' ');
    },
  
    // Convierte un string a camelCase
    toCamelCase: (str) => {
      if (!str) return '';
      return str
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());
    },
  
    // Elimina espacios al inicio y al final, y reemplaza múltiples espacios internos por uno solo
    normalizeSpaces: (str) => {
      if (!str) return '';
      return str.trim().replace(/\s+/g, ' ');
    },
  
    // Cuenta la cantidad de palabras en un string
    countWords: (str) => {
      if (!str) return 0;
      return str.trim().split(/\s+/).filter(Boolean).length;
    },
  
    // Reemplaza todas las ocurrencias de un substring por otro (sin usar regex)
    replaceAll: (str, find, replace) => {
      if (!str) return '';
      return str.split(find).join(replace);
    },
  
    // Verifica si un string está vacío o sólo tiene espacios
    isEmptyOrSpaces: (str) => {
      return !str || str.trim().length === 0;
    },
  
    // Trunca un string a una longitud máxima y añade "..." si se recorta
    truncate: (str, maxLength) => {
      if (!str) return '';
      if (str.length <= maxLength) return str;
      return str.slice(0, maxLength) + '...';
    },
  
    // Convierte un string a kebab-case (ej: "Hola Mundo" => "hola-mundo")
    toKebabCase: (str) => {
      if (!str) return '';
      return str
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    },
  };
  
  export default stringUtils;
  